import { FC } from "react";
import { IconProps } from "@/shared/types/icon";
import { Svg } from "@abel-technologies-as/components";

export const Envelope: FC<IconProps> = (props) => {
	return (
		<Svg width="20" height="16" viewBox="0 0 20 16" fill="none" {...props}>
			<path
				d="M1.66663 2.99997L7.42748 6.26411C9.55129 7.46748 10.4486 7.46748 12.5724 6.26411L18.3333 2.99997M7.58231 0.947095C9.19938 0.906468 10.8005 0.90647 12.4176 0.9471C15.0414 1.01302 16.3532 1.04599 17.2958 1.99218C18.2384 2.93837 18.2657 4.21568 18.3202 6.77029C18.3377 7.59169 18.3377 8.40824 18.3202 9.22964C18.2657 11.7843 18.2384 13.0616 17.2958 14.0078C16.3532 14.9539 15.0414 14.9869 12.4176 15.0528C10.8005 15.0935 9.19939 15.0935 7.58232 15.0528C4.95857 14.9869 3.6467 14.9539 2.70409 14.0078C1.76148 13.0616 1.73424 11.7843 1.67976 9.22964C1.66225 8.40824 1.66225 7.59168 1.67976 6.77027C1.73424 4.21566 1.76148 2.93836 2.70409 1.99217C3.64669 1.04597 4.95857 1.01301 7.58231 0.947095Z"
				stroke={props.color || "#146AE1"}
				strokeWidth="1.66667"
				stroke-linejoin="round"
			/>
		</Svg>
	);
};
